import React from 'react';

export default function SolDivider({ className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-4 py-8 ${className}`}>
      <div className="h-[1px] flex-1 bg-gradient-to-r from-transparent via-stone-200 to-transparent"></div>
      <div className="relative flex items-center justify-center">
        <div className="w-8 h-8 rounded-full bg-[#F6B40E] opacity-10 animate-pulse absolute"></div>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-[#F6B40E] relative">
          <circle cx="12" cy="12" r="3" fill="currentColor" />
          {[0, 45, 90, 135, 180, 225, 270, 315].map(deg => (
            <line 
              key={deg} 
              x1="12" y1="6" x2="12" y2="2" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              transform={`rotate(${deg} 12 12)`} 
            />
          ))}
        </svg>
      </div>
      <div className="h-[1px] flex-1 bg-gradient-to-r from-transparent via-stone-200 to-transparent"></div>
    </div>
  );
}